module.exports = __webpack_public_path__ + "img/extinct-1024.df69cee5.jpg";